import * as actionTypes from './actionTypes';

export const addChartChooseCategorySuccess = (val) => {
  return {
    type: actionTypes.ADD_CHART_CHOOSE_CATEGORY_SUCCESS,
    val: val
  }
}

export const categoryKpiDataFetched = (val) => {
  return {
    type: actionTypes.ANALYTICS_CATEGORY_KPI_DATA_FETCHED,
    val: val
  }
}

export const chartDetailsCompleted = (val) => {
  return {
    type: actionTypes.CHART_DETAILS_COMPLETED,
    val: val
  }
}

export const agreegateDataFetched = (val) => {
  return {
    type: actionTypes.KPI_AGRREGATE_DATA_FETCHED,
    val: val
  }
}

export const chartPrivacySettingsCompleted = (val) => {
  return {
    type: actionTypes.CHART_PRIVACY_SETTINGS_COMPLETED,
    val: val
  }
}

export const chartGoBackPressed = (val) => {
  return {
    type: actionTypes.CHART_GO_BACK_PRESSED,
    val: val
  }
}

export const createChartSuccess = (val) => {
  return {
    type: actionTypes.ADD_CHART_SUCCESS,
    val: val
  }
}

export const editChartSuccess = (val) => {
  return {
    type: actionTypes.EDIT_CHART_SUCCESS,
    val: val
  }
}

export const editChartLoaded = (val) => {
  return {
    type: actionTypes.CHART_LOADED,
    val: val
  }
}

export const leaveCreateChart = () => {
  return {
    type: actionTypes.LEAVE_CREATE_CHART
  }
}

export const leaveEditChart = () => {
  return {
    type: actionTypes.LEAVE_EDIT_CHART
  }
}
